import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import "./header-active.css";
import logo from "../assets/Logo.svg";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const currentPath = window.location.pathname;
  const navigate = useNavigate(); 

  return (
    <header className="cm-header-wrapper">
      <div className="cm-header-container">

        {/* LOGO */}
        <div className="cm-header-logo">
          <img src={logo} alt="CM Group Logo" />
        </div>

        {/* DESKTOP MENU */}
        <nav className="cm-header-nav">
          <a href="/" className={currentPath === "/" ? "active" : ""}>Home</a>

          <a href="/about" className={currentPath === "/about" ? "active" : ""}>
            About
          </a>

          {/* SERVICES DROPDOWN */}
          <div
            className="dropdown"
            onMouseEnter={() => setServicesOpen(true)}
            onMouseLeave={() => setServicesOpen(false)}
          >
            <button
              className={`dropdown-btn ${
                currentPath.includes("energy") ||
                currentPath.includes("consulting") ||
                currentPath.includes("infrastructure")
                  ? "active"
                  : ""
              }`}
            >
              What We Do
            </button>

            {servicesOpen && (
              <div className="dropdown-menu">
                <a
                  href="/green-energy/greenenergy"
                  className={currentPath === "/green-energy/greenenergy" ? "active" : ""}
                >
                  Solar Energy Solutions
                </a>
                <a
                  href="/developers/promoters"
                  className={currentPath === "/developers/promoters" ? "active" : ""}
                >
                  Promoters & Developers
                </a>
              </div>
            )}
          </div>

  
          <a href="/careers" className={currentPath === "/careers" ? "active" : ""}>
            Careers
          </a>
        </nav>

        {/* RIGHT SECTION */}
        <div className="cm-header-right">
          <div className="cm-header-phone">
            <span><i className="fas fa-phone"></i></span> +91 99446 62747
          </div>

          <a href="/contact" className="cm-header-whatsapp-btn">
             Contact Us
          </a>
        </div>

        {/* MOBILE MENU TOGGLE */}
        <div
          className="cm-header-mobile-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? "✖" : "☰"}
        </div>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="cm-header-mobile-menu">
          <a href="/" className={currentPath === "/" ? "active" : ""}>Home</a>

          <a href="/about" className={currentPath === "/about" ? "active" : ""}>
            About
          </a>

          {/* MOBILE SERVICES DROPDOWN */}
          <div className="mobile-dropdown">
            <button
              className="mobile-dropdown-btn"
              onClick={() => setServicesOpen(!servicesOpen)}
            >
              What We Do {servicesOpen ? "▲" : "▼"}
            </button>

            {servicesOpen && (
              <div className="mobile-dropdown-menu">
                <a href="/green-energy/greenenergy">Solar Energy Solutions</a>
                <a href="/developers/promoters">Promoters & Developers</a>
              </div>
            )}
          </div>

          <a href="/careers" className={currentPath === "/careers" ? "active" : ""}>
            Careers
          </a>

          <a href="/contact" className={currentPath === "/contact" ? "active" : ""}>
            Contact
          </a>

<button
  className="cm-header-mobile-whatsapp-btn"
  onClick={() => window.location.href = "tel:+919944862747"}
>
  Call Us: +91 99446 62747
</button>
        </div>
      )}
    </header>
  );
}
